module.exports = __webpack_public_path__ + "static/media/021-dental floss.764958bd.svg";